import { toast } from 'react-toastify'
import { UIDialog } from 'src/components/ui/Modal'
import Text from 'src/components/ui/Text'
import { publishModel } from 'src/services/helpers/model'

/**
 * Publish a LoRA
 *
 * @returns The operation result
 *   - `true`: The operation was successful
 *   - `false`: Error occurred during the operation
 *   - `undefined`: The operation was canceled
 */
export async function publishLora(
  modelId: string,
  opts?: {
    skipConfirm?: boolean
  },
) {
  const toProceed =
    opts?.skipConfirm ||
    (await UIDialog.confirm({
      heading: (
        <Text i18nKey="market:model.action.publish-lora.confirm-dialog.title" />
      ),
      content: (
        <Text i18nKey="market:model.action.publish-lora.confirm-dialog.content" />
      ),
    }))
  if (toProceed) {
    try {
      await publishModel(modelId)
      return true
    } catch (err) {
      toast.error(String(err))
    }
  }
}
